module.exports = __webpack_public_path__ + "img/substance-logo-2023.b0dfaf32.png";